import { RefreshToken } from "features/Core/Authentification/state/authentificationSlice";
import { GetUnixCurrentUTCTime } from '../shared/utils/common';
import { refreshTokenModel } from "features/Core/Authentification/state/login-interfaces";
import { Middleware } from 'redux';
import jwtDecode from 'jwt-decode';

let isRefreshing = false;
// The backend writes `valid` in Unix milliseconds, and GetUnixCurrentUTCTime() returns milliseconds too.
const REFRESH_BEFORE_EXPIRY_MS = 10_000;

const TokenRefreshMiddleware: Middleware = (storeAPI) => (next) => (action) => {

  const rememberMe = JSON.parse(localStorage.getItem('rememberMe') as string);
  const state = storeAPI.getState();
  const access_token_app = rememberMe
    ? localStorage.getItem('AuthTokenApp')
    : sessionStorage.getItem('AuthTokenApp');

  if (access_token_app !== null) {
    if (action.type.startsWith('Slice/') && access_token_app) {
      const decoded: any = jwtDecode(access_token_app);
      const unixTime = GetUnixCurrentUTCTime();

      if (decoded.valid && decoded.valid - unixTime < REFRESH_BEFORE_EXPIRY_MS) {
        const refresh_token = rememberMe
          ? localStorage.getItem('RefreshToken')
          : sessionStorage.getItem('RefreshToken');

        const access_token = rememberMe
          ? localStorage.getItem('AuthToken')
          : sessionStorage.getItem('AuthToken');

        const tenantId = state.authentificationSlice?.logTenantId;

        if (refresh_token != null && access_token != null) {
          const refreshModel: refreshTokenModel = {
            refreshToken: refresh_token,
            accessToken: access_token,
            accessTokenApp: access_token_app,
            tenantId: tenantId
          };

          if (!isRefreshing) {
            isRefreshing = true;
            storeAPI
              .dispatch(RefreshToken(refreshModel) as any)
              .then((data: any) => {
                if (data.type === "AuthentificationSlice/RefreshToken/rejected") {
                  isRefreshing = false;
                  sessionStorage.clear();
                  localStorage.clear();
                  window.location.replace("/login");
                }
                else {
                  isRefreshing = false;
                  return;
                }
              })
              .catch((error: any) => {
                isRefreshing = false;
                sessionStorage.clear();
                localStorage.clear();
                window.location.replace("/login");
              });
            // No return here: the action that started the refresh still has to reach the reducers.
          }
        }
      }
    }
    return next(action);
  }
  else {
    sessionStorage.clear();
    localStorage.clear();
    window.location.replace("/login");
  }
};

export default TokenRefreshMiddleware;

